// Login form open and close
import {
    introSwiper,
    servicesSwiper
} from "../swipers/swipers";

$(document).ready(function () {
    const body = $('body'),
        header = $('.header'),
        mainNav = $('.main-nav'),
        overlay = $('.overlay'),
        loginForm = $('.login-section'),
        loginFormShowBtn = $('.login-btn'),
        loginFormCloseBtn = $('.login-section .close-icon');

    loginFormShowBtn.on('click', function (e) {
        body.css('overflow', 'hidden');
        loginForm.addClass('show');
        overlay.addClass('open');
        if (body.hasClass('body-index')) {
            introSwiper.autoplay.stop();
            servicesSwiper.autoplay.stop();
        }
        e.preventDefault();
    });

    loginFormCloseBtn.on('click', function () {
        loginForm.removeClass('show');
        if (!mainNav.hasClass('open')) {
            body.css('overflow', 'visible');
            overlay.removeClass('open');
        }
        header.css('pointer-events', 'auto');
    });
});